
import { Component , Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

interface ICustomerIframe {
  url?: string
}

@Component
export default class CustomerIframe extends tsx.Component<ICustomerIframe> {
  
  @Prop() public url!: string
  
  constructor(props: any) {
    super(props)
  }
  
  
  isIos () {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  
  }
  
  render() {
    return (
      <div class='customer-container'>
        <div class='custom-container ignore'>
        
        </div>
        <iframe width="100%" height='100%' src={this.$props.url}></iframe>
      </div>
    )
  }
  
}